// Stub for @react-native-vector-icons/material-design-icons
// This redirects to Expo's MaterialCommunityIcons for web compatibility

export default require('@expo/vector-icons/MaterialCommunityIcons').default;
